// extracted by mini-css-extract-plugin
export default {"container":"T3-z","topReviewHeading":"U3-z","criticalReview":"V3-z","favorableReview":"W3-z","vsSeparator":"X3-z"};